import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "../reduxSlices/loginSlice";
import registerReducer from "../reduxSlices/registerSlice";
import classReducer from "../reduxSlices/classesSlice";
import profileReducer from "../reduxSlices/profileSlice";
import applicationReducer from "../reduxSlices/applicationSlice";
import selectClassReducer from "../reduxSlices/selectClassSlice";
import forgotpasswordReducer from "../reduxSlices/forgotPasswordslice";
import resetPasswordReducer from "../reduxSlices/resetPasswordSlice";
import attendanceReducer from "../reduxSlices/attendaceSlice";
import languageSlice from "../reduxSlices/languageSlice";
import  degreeSlice from '../reduxSlices/degreeSlice';
import testSlice from '../reduxSlices/testSlice';
import  alumniSlice from '../reduxSlices/alumniSlice';
import invoiceSlice from "../reduxSlices/invoiceSlice";
export default configureStore({
  reducer: {
    loginRequest: loginReducer,
    resgisterRequest: registerReducer,
    classData: classReducer,
    profileData: profileReducer,
    applicationData: applicationReducer,
    selectClassData: selectClassReducer,
    forgotPasswordRequest:forgotpasswordReducer,
    resetPasswordRequest:resetPasswordReducer,
    attendanceData:attendanceReducer,
    invoiceData: invoiceSlice,
    language:languageSlice,
    degreeData:degreeSlice,
    testData:testSlice,
    alumniData:alumniSlice
  },
});
